var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete_outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.16675 7.5H6.66675V8V16.3333V16.8333H7.16675H13.8334H14.3334V16.3333V8V7.5H13.8334H7.16675ZM13.0632 4.18689L13.2096 4.33333H13.4167H15.8334V5H5.16675V4.33333H7.58341H7.79052L7.93697 4.18689L8.62385 3.5H12.3763L13.0632 4.18689ZM7.16675 17.5C6.52622 17.5 6.00008 16.9739 6.00008 16.3333V6.83333H15.0001V16.3333C15.0001 16.9739 14.4739 17.5 13.8334 17.5H7.16675Z",
    fill: "#EF6D44",
    stroke: "#EF6D44"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteOutline);
export default __webpack_public_path__ + "static/media/delete_outline.624fac017451524671337c6dd9ff88da.svg";
export { ForwardRef as ReactComponent };